import React, { useMemo } from 'react';
// import { useSearchParams } from 'react-router-dom';
import {
  Box,
  Avatar,
  Typography,
  useTheme,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  Chip,
} from '@mui/material';
import {
  Download,
  WhatsApp,
} from '@mui/icons-material';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
  type MRT_PaginationState,
  type MRT_RowSelectionState,
} from 'material-react-table';
import { Application, applicationsService } from '@/services/applications/applicationsService';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/store/types';
import { updateApplicationStatus } from '@/store';
import { useAuth } from '@/hooks';

interface ApplicationsTableProps {
  applications: Application[];
  loading?: boolean;
  totalCount?: number;
  pagination?: MRT_PaginationState;
  onPaginationChange?: (pagination: MRT_PaginationState) => void;
  enablePagination?: boolean;
  enableSelection?: boolean;
  onRowSelectionChange?: (selectedRows: MRT_RowSelectionState) => void;
  selectedRows?: MRT_RowSelectionState;
  customTableOptions?: Partial<MRT_TableOptions<Application>>;
  feedId?: string;
  onStatusUpdate?: (applicationId: string, newStatus: string) => void;
}

export const ApplicationsTable: React.FC<ApplicationsTableProps> = ({
  applications,
  loading = false,
  totalCount,
  pagination = { pageIndex: 0, pageSize: 10 },
  onPaginationChange,
  enablePagination = true,
  enableSelection = false,
  onRowSelectionChange,
  selectedRows = {},
  customTableOptions = {},
  // feedId,
  // onStatusUpdate,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useAuth();
  const handleDownloadResume = (resumeUrl: string) => {
    window.open(resumeUrl, '_blank', 'noopener,noreferrer');
  };

  const handleWhatsAppChat = (whatsappNumber: string) => {
    if (whatsappNumber) {
      const cleanNumber = whatsappNumber.replace(/[^\d]/g, '');
      const url = `https://web.whatsapp.com/send?phone=${cleanNumber}&text=Hi👋`;
      window.open(url, '_blank');
    }
  };

  const handleStatusChange = async (applicationId: string, userId: string, newStatus: string, feedId: string, feed: Application) => {
    console.log('handleStatusChange called: 12', { applicationId, userId, newStatus, feedId });
    console.log(feed);

    if (!feedId) {
      console.error('feedId is required for status update');
      return;
    }

    console.log(feed?.feedId?.feedType?.name)
    try {
      console.log('Making API call to update status...');
      const result = await applicationsService.updateApplicationStatus(feedId,feed?.feedId?.feedType?.name==='job'?userId:  user?.id!, newStatus as any);
      console.log('Status update result:', result);

      dispatch(updateApplicationStatus({ applicationId, status: newStatus }));
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const columns = useMemo<MRT_ColumnDef<Application>[]>(
    () => [
      {
        id: 'applicant',
        header: 'Applicant',
        size: 250,
        enableSorting: false,
        Cell: ({ row }) => {
          const user = row.original.userId;
          if (!user) {
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ width: 40, height: 40 }}>U</Avatar>
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    Unknown User
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    No email
                  </Typography>
                </Box>
              </Box>
            );
          }
          console.log(row.original)
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 , cursor:'pointer'}} onClick={()=>navigate('/profile/'+user._id)}>
              <Avatar
                src={user.profilePictureId?.url
                  
                }
                sx={{ width: 40, height: 40 }}
              >
                {user.name?.charAt(0) || 'U'}
              </Avatar>
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {user.name || 'Unknown User'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {user.email || 'No email'}
                </Typography>
              </Box>
            </Box>
          );
        },
      },
      //  {
      //   accessorKey: 'userId.email',
      //   header: 'Email',
      //   size: 180,
      //   enableSorting: false,
      //   Cell: ({ cell }) => (
      //     <Typography variant="body2">
      //       {cell.getValue() as string || 'Not specified'}
      //     </Typography>
      //   ),
      // },
       {
        accessorKey: 'userId.whatsappNumber',
        header: 'Contact Number',
        size: 180,
        enableSorting: false,
        Cell: ({ cell }) => (
          <Typography variant="body2">
            {cell.getValue() as string || 'Not specified'}
          </Typography>
        ),
      },
      // {
      //   accessorKey: 'userId.designation',
      //   header: 'Designation',
      //   size: 180,
      //   enableSorting: false,
      //   Cell: ({ cell }) => (
      //     <Typography variant="body2">
      //       {cell.getValue() as string || 'Not specified'}
      //     </Typography>
      //   ),
      // },
      {
        id: 'location',
        header: 'Location',
        size: 150,
        enableSorting: false,
        Cell: ({ row }) => {
          const city = row.original.userId?.city;
          const state = row.original.userId?.state;
          const location = [city, state].filter(Boolean).join(', ');
          
          return (
            <Typography variant="body2">
              {location || 'Not specified'}
            </Typography>
          );
        },
      },
       {
        id: 'actions',
        header: 'Actions',
        size: 120,
        enableSorting: false,
        Cell: ({ row }) => {
          const feedType = row.original.feedId.feedType.name
          const user = row.original.userId;
          console.log(user)

          const resumeUrl = user?.jobPreferences?.resumeId?.url;
          const whatsappNumber = user?.whatsappNumber;
          // const resumeFileName = user?.jobPreferences?.resumeId?.originalName;

          return (
            <Box sx={{ display: 'flex', gap: 1 }}>
              {resumeUrl && feedType!=='jobSeeker' &&(
                <Tooltip title="Download Resume">
                  <IconButton
                    size="small"
                    onClick={() => handleDownloadResume(resumeUrl)}
                    sx={{
                      color: 'primary.main',
                      '&:hover': {
                        bgcolor: 'primary.lighter',
                      },
                    }}
                  >
                    <Download fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              {whatsappNumber && (
                <Tooltip title="Chat on WhatsApp">
                  <IconButton
                    size="small"
                    onClick={() => handleWhatsAppChat(whatsappNumber)}
                    sx={{
                      color: '#25D366',
                      '&:hover': {
                        bgcolor: 'rgba(37, 211, 102, 0.1)',
                      },
                    }}
                  >
                    <WhatsApp fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      },
    {
              id: 'status',
              header: 'Status av',
              size: 150,
              enableSorting: false,
              Cell: ({ row }) => {
                const currentStatus = row.original.status || 'Pending';
                const userId = row.original.userId._id;
                const applicationId = row.original._id;
                const feed_id = row.original.feedId._id;
                const isJobSeeker = row.original.feedId.feedType.name === 'jobSeeker';

                const statusColorMap = {
                  'Pending': 'default',
                  'Under review': 'info',
                  'Shortlisted': 'success',
                  'Rejected': 'error',
                } as const;
console.log(row.original)
                if (isJobSeeker) {
                  return (
                    <Chip
                      label={currentStatus}
                      color={statusColorMap[currentStatus as keyof typeof statusColorMap] || 'default'}
                      size="small"
                    />
                  );
                }

                return (
                  <FormControl size="small" fullWidth>
                    <Select
                      value={currentStatus}
                      onChange={(e) => handleStatusChange(applicationId, userId, e.target.value, feed_id, row?.original)}
                      sx={{
                        minWidth: 120,
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none'
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          border: 'none'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          border: 'none'
                        }
                      }}
                    >
                      <MenuItem value="Pending">
                        <Chip label="Pending" color="default" size="small" />
                      </MenuItem>
                      <MenuItem value="Under review">
                        <Chip label="Under review" color="info" size="small" />
                      </MenuItem>
                      <MenuItem value="Shortlisted">
                        <Chip label="Shortlisted" color="success" size="small" />
                      </MenuItem>
                      <MenuItem value="Rejected">
                        <Chip label="Rejected" color="error" size="small" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                );
              },
            },
//       {
//         id: 'status',
//         header: 'Status',
//         size: 150,
//         enableSorting: false,
//         Cell: ({ row }) => {
//           const currentStatus = row.original.status || 'Pending';
//           const userId = row.original.userId._id;
//           const applicationId = row.original._id;
//           const feed_id = row.original.feedId._id;
// console.log(row.original)
//           return (
//             <FormControl size="small" fullWidth>
//               <Select
//                 value={currentStatus}
//                 onChange={(e) => handleStatusChange(applicationId, userId, e.target.value, feed_id)}
//                 sx={{ 
//                   minWidth: 120,
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     border: 'none'
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     border: 'none'
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     border: 'none'
//                   }
//                 }}
//               >
//                 <MenuItem value="Pending">
//                   <Chip label="Pending" color="default" size="small" />
//                 </MenuItem>
//                 <MenuItem value="Under review">
//                   <Chip label="Under review" color="info" size="small" />
//                 </MenuItem>
//                 <MenuItem value="Shortlisted">
//                   <Chip label="Shortlisted" color="success" size="small" />
//                 </MenuItem>
//                 <MenuItem value="Rejected">
//                   <Chip label="Rejected" color="error" size="small" />
//                 </MenuItem>
//               </Select>
//             </FormControl>
//           );
//         },
//       },
       {
        accessorKey: 'appliedAt',
        header: 'Applied Date',
        size: 150,
        enableSorting: true,
        sortingFn: 'datetime',
        Cell: ({ cell }) => (
          <Box>
            <Typography variant="body2">
              {moment(cell.getValue() as string).format('MMM DD, YYYY')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {moment(cell.getValue() as string).fromNow()}
            </Typography>
          </Box>
        ),
      },
      // {
      //   accessorKey: 'isActive',
      //   header: 'Status',
      //   size: 100,
      //   enableSorting: true,
      //   Cell: ({ cell }) => (
      //     <Chip
      //       label={cell.getValue() ? 'Active' : 'Inactive'}
      //       color={cell.getValue() ? 'success' : 'default'}
      //       size="small"
      //       variant="outlined"
      //     />
      //   ),
      // },
    ],
    [navigate]
  );

  const defaultTableOptions: Partial<MRT_TableOptions<Application>> = {
    columns,
    data: applications,
    enableRowSelection: enableSelection,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enablePagination,
    enableSorting: true,
    enableBottomToolbar: enablePagination,
    enableTopToolbar: false,
    muiTableBodyRowProps: {
      sx: {
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        border: 'none',
      },
    },
    muiTableProps: {
      sx: {
        tableLayout: 'fixed',
      },
    },
    state: {
      isLoading: loading,
      ...(enablePagination && { pagination }),
      ...(enableSelection && { rowSelection: selectedRows }),
    },
    ...(enablePagination && onPaginationChange && {
      onPaginationChange: (updaterOrValue: any) => {
        if (typeof updaterOrValue === 'function') {
          const newPagination = updaterOrValue(pagination);
          onPaginationChange(newPagination);
        } else {
          onPaginationChange(updaterOrValue);
        }
      },
      rowCount: totalCount,
      manualPagination: !!onPaginationChange,
    }),
    ...(enableSelection && onRowSelectionChange && {
      onRowSelectionChange: (updaterOrValue: any) => {
        if (typeof updaterOrValue === 'function') {
          const newSelection = updaterOrValue(selectedRows);
          onRowSelectionChange(newSelection);
        } else {
          onRowSelectionChange(updaterOrValue);
        }
      },
    }),
  };

  const tableOptions = {
    ...defaultTableOptions,
    ...customTableOptions,
  } as MRT_TableOptions<Application>;

  const table = useMaterialReactTable(tableOptions);

  return <MaterialReactTable table={table} />;
};